import TomSelect from 'tom-select';
// import TomSelect from 'tom-select/dist/js/tom-select.complete.min.js';

function tomSelectSetup() {

  document.querySelectorAll(".tom-select-bucket-copy-multiple").forEach(el => {
    if (!el.tomSelect) {
      el.tomSelect = new TomSelect(el, { maxOptions: null });
    }
  });

  document.querySelectorAll(".tom-select-database-multiple").forEach(el => {
    if (!el.tomSelect) {
      el.tomSelect = new TomSelect(el, { maxOptions: null });
    }
  });

  document.querySelectorAll(".tom-select-deploy-validation-user").forEach(el => {
    if (!el.tomSelect) {
      el.tomSelect = new TomSelect(el, { allowEmptyOption: true });
    }
  });

  document.querySelectorAll(".tom-select-deploy-validation-project").forEach(el => {
    if (!el.tomSelect) {
      el.tomSelect = new TomSelect(el, { allowEmptyOption: true });
    }
  });

  document.querySelectorAll(".tom-select-deploy-validation-approved").forEach(el => {
    if (!el.tomSelect) {
      el.tomSelect = new TomSelect(el, {});
    }
  });

  document.querySelectorAll(".tom-select-deploy-validation-reviewed").forEach(el => {
    if (!el.tomSelect) {
      el.tomSelect = new TomSelect(el, {});
    }
  });

  document.querySelectorAll(".tom-select-basic").forEach(el => {
    if (!el.tomSelect) {
      el.tomSelect = new TomSelect(el, {});
    }
  });
};


document.addEventListener('DOMContentLoaded', function () {
  tomSelectSetup();
});

document.addEventListener('turbo:load', function () {
  tomSelectSetup();
});

document.addEventListener('turbo:render', function () {
  tomSelectSetup();
});

document.addEventListener('turbo:morph', function () {
  tomSelectSetup();
});

